import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_LinkedHashSet(_this__u8e3s4) {
}
var LinkedHashSetClass;
function LinkedHashSet() {
  if (LinkedHashSetClass === VOID) {
    class $ extends HashSet() {
      static v1() {
        var $this = this.ha();
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static z1(elements) {
        var $this = this.ia(elements);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static hc(initialCapacity, loadFactor) {
        var $this = this.ka(initialCapacity, loadFactor);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static q(initialCapacity) {
        return this.hc(initialCapacity, 1.0);
      }
      k6() {
        return this.w1_1.n9();
      }
    }
    initMetadataForClass($, 'LinkedHashSet', $.v1, VOID, [HashSet(), KtMutableSet()]);
    LinkedHashSetClass = $;
  }
  return LinkedHashSetClass;
}
//region block: exports
export {
  LinkedHashSet as LinkedHashSet2tkztfx86kyx2,
};
//endregion

//# sourceMappingURL=LinkedHashSet.mjs.map
